export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  categoryName: string;
  author: string;
  publishedAt: string;
  updatedAt: string;
  readTime: string;
  tags: string[];
  imageUrl: string;
}

export const articles: Article[] = [
  {
    id: 'art-1',
    slug: 'how-to-identify-fake-91-pages',
    title: '如何识别虚假91页面？五大特征帮你快速辨别',
    excerpt: '虚假91页面层出不穷，它们往往模仿官方网站界面，诱导用户下载恶意软件。本文总结五大关键识别特征，帮助你在访问前快速判断页面真伪。',
    content: `<p>近年来，仿冒91平台的虚假页面数量急剧增加。这些页面往往高度模仿真实界面，让普通用户难以分辨。一旦用户在这些虚假页面上操作，就可能面临恶意软件感染、个人信息泄露甚至财产损失的风险。</p>

<h2>一、检查网址（URL）的合法性</h2>
<p>虚假页面最明显的特征是网址异常。正规平台的网址通常简洁明了，而虚假页面往往使用奇怪的域名组合。请仔细检查浏览器地址栏中的完整网址，留意是否存在拼写错误、多余字符或异常的后缀名。</p>
<p>需要注意的是，攻击者经常使用"域名欺骗"技术，使用看起来非常相似的字符替换原域名中的字母，例如用数字"1"替换字母"l"，或用"rn"组合模仿"m"。请务必逐字核对。</p>

<h2>二、观察页面设计与排版</h2>
<p>虚假页面在视觉上通常会暴露出质量低劣的痕迹。注意以下细节：</p>
<ul>
<li>字体大小和样式不统一</li>
<li>图片模糊或有明显的拉伸变形</li>
<li>按钮位置偏移或点击无效</li>
<li>页面布局在不同设备上显示异常</li>
<li>存在明显的拼写错误或语法问题</li>
</ul>

<h2>三、检查安全证书</h2>
<p>点击浏览器地址栏左侧的锁形图标，查看网站的SSL/TLS证书信息。正规网站的证书信息完整，包括颁发机构、有效期和所属组织。虚假页面可能使用自签名证书或已过期的证书，甚至根本没有HTTPS加密。</p>

<h2>四、警惕异常弹窗和强制下载</h2>
<p>虚假页面最常见的攻击手段就是弹窗诱导。当你遇到以下情况时，应立即关闭页面：</p>
<ul>
<li>页面自动弹出"您的设备已感染病毒"类警告</li>
<li>要求立即下载某个"安全工具"或"播放器插件"</li>
<li>弹出"点击允许继续"的通知权限请求</li>
<li>页面自动触发文件下载</li>
</ul>

<h2>五、核实联系方式与备案信息</h2>
<p>正规平台通常在页面底部提供完整的联系方式、ICP备案号以及相关的营业执照信息。虚假页面往往缺失这些内容，或提供虚假的备案号。你可以通过工信部ICP备案查询系统验证备案号的真实性。</p>

<h2>总结</h2>
<p>在访问任何涉及下载的页面之前，请务必保持警惕，多方验证信息来源的可靠性。记住：安全第一，不确定的时候，不要点击、不要下载、不要输入任何个人信息。遵守法律法规，远离非法内容。</p>`,
    categorySlug: 'security-news',
    categoryName: '安全资讯',
    author: '安全指南编辑部',
    publishedAt: '2026-07-20',
    updatedAt: '2026-07-23',
    readTime: '8 分钟',
    tags: ['虚假页面', '安全识别', '钓鱼网站', '网络安全'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20clean%20modern%20digital%20security%20scene%20showing%20a%20laptop%20screen%20with%20warning%20symbol%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20high%20quality%20photography&width=1200&height=600&seq=article-fake-pages-full&orientation=landscape',
  },
  {
    id: 'art-2',
    slug: 'malware-download-risks',
    title: '恶意下载的常见套路与防护指南',
    excerpt: '恶意软件常伪装成正常应用程序，通过虚假下载链接传播。了解这些套路，学会使用有效的防护手段，是保护个人设备和数据安全的关键。',
    content: `<p>恶意下载是当前最常见的网络攻击方式之一。攻击者将恶意软件伪装成热门应用或工具，通过各种渠道分发，一旦用户下载并安装，设备就可能被远程控制、数据被盗或沦为僵尸网络的一部分。</p>

<h2>常见的恶意下载套路</h2>

<h3>1. 虚假下载按钮</h3>
<p>页面上散布着多个"下载"按钮，其中大部分指向广告或恶意链接，只有少数（甚至没有）指向真正的目标文件。这种混淆手法让用户难以找到正确的下载入口。</p>

<h3>2. 捆绑安装</h3>
<p>下载的安装包中捆绑了额外的恶意组件。即使用户从看似正常的渠道下载，安装过程中也可能被悄然植入广告软件、挖矿程序或后门木马。</p>

<h3>3. 仿冒应用</h3>
<p>攻击者制作外观和名称与正版应用高度相似的仿冒版本，通过非官方渠道分发。这些仿冒应用可能窃取账号密码、通讯录、短信甚至銀行信息。</p>

<h3>4. 压缩包陷阱</h3>
<p>看似普通的压缩文件（ZIP、RAR等），解压后却释放出可执行文件或恶意脚本。攻击者往往使用双扩展名（如 setup.pdf.exe）来迷惑用户。</p>

<h2>有效的防护手段</h2>

<h3>安装可靠的安全软件</h3>
<p>选择信誉良好的安全防护软件，保持病毒库实时更新。安全软件可以在下载前检测文件安全性，安装时拦截可疑行为。</p>

<h3>仅从官方渠道下载</h3>
<p>不随意点击来路不明的下载链接。需要下载应用时，优先选择官方网站、官方应用商店或经过认证的第三方平台。</p>

<h3>校验文件完整性</h3>
<p>下载完成后，对比文件的MD5、SHA1或SHA256哈希值与官方公布的值是否一致。任何差异都意味着文件可能被篡改。</p>

<h3>查看用户评价与反馈</h3>
<p>在下载陌生应用前，查看其他用户的评价。如果大量用户报告异常行为，应立即放弃下载。</p>

<h3>保持系统更新</h3>
<p>操作系统和应用程序的更新通常包含安全漏洞修复。及时安装更新可以有效阻止利用已知漏洞的攻击。</p>

<h2>中了恶意软件怎么办？</h2>
<ol>
<li>立即断开网络连接，防止数据持续泄露</li>
<li>使用安全软件进行全盘扫描和清除</li>
<li>修改所有重要账号的密码</li>
<li>检查银行和支付平台的交易记录</li>
<li>如涉及财产损失，及时向公安机关报案</li>
</ol>`,
    categorySlug: 'malware-prevention',
    categoryName: '恶意下载防范',
    author: '安全指南编辑部',
    publishedAt: '2026-07-18',
    updatedAt: '2026-07-22',
    readTime: '10 分钟',
    tags: ['恶意软件', '下载安全', '防病毒', '设备安全'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20security%20concept%20with%20shield%20icon%20on%20laptop%2C%20warm%20cream%20and%20amber%20background%2C%20soft%20lighting%2C%20professional%20editorial%20style%2C%20clean%20minimalist%20composition&width=1200&height=600&seq=article-malware-full&orientation=landscape',
  },
  {
    id: 'art-3',
    slug: 'privacy-protection-basics',
    title: '网络隐私保护基础：你的个人信息可能正在被泄露',
    excerpt: '每一次点击、每一次下载都可能成为隐私泄露的源头。本文从基础出发，教你如何识别隐私风险并保护个人信息不被非法获取和滥用。',
    content: `<p>在数字化时代，个人信息的价值日益凸显。你的浏览记录、通讯录、位置信息、甚至聊天内容都可能成为不法分子觊觎的目标。了解隐私保护的基本知识，是每位网民的必修课。</p>

<h2>你的哪些信息最有价值？</h2>
<ul>
<li><strong>身份信息：</strong>姓名、身份证号、护照号码</li>
<li><strong>联系方式：</strong>手机号、邮箱地址、家庭住址</li>
<li><strong>财务信息：</strong>银行卡号、支付密码、交易记录</li>
<li><strong>生物特征：</strong>人脸照片、声纹、指纹数据</li>
<li><strong>社交关系：</strong>通讯录、聊天记录、社交网络图谱</li>
<li><strong>行为数据：</strong>浏览历史、搜索记录、位置轨迹</li>
</ul>

<h2>隐私泄露的常见途径</h2>

<h3>1. 恶意应用过度索权</h3>
<p>很多恶意应用在安装时会要求过多的权限，例如一个手电筒应用却要求读取通讯录和短信。在授予权限前，请思考该权限是否与应用功能相关。不相关的权限请求应当拒绝。</p>

<h3>2. 公共Wi-Fi窃听</h3>
<p>公共Wi-Fi网络通常缺乏加密保护，攻击者可以通过中间人攻击截获你的网络通信数据。在公共Wi-Fi环境下，避免登录重要账号或进行支付操作。</p>

<h3>3. 社工诱导</h3>
<p>攻击者通过社交工程手段，伪装成客服、朋友或权威机构，诱导用户主动提供敏感信息。对于任何主动索取个人信息的请求，都要保持高度警惕。</p>

<h2>实用的隐私保护措施</h2>
<ol>
<li>使用强密码并为不同平台设置不同密码</li>
<li>开启双因素认证增加账号安全性</li>
<li>定期检查应用的权限设置并移除不必要的授权</li>
<li>使用VPN加密网络通信，尤其在公共Wi-Fi环境下</li>
<li>谨慎分享位置信息和个人照片</li>
<li>定期清理浏览器Cookie和缓存</li>
<li>使用隐私保护浏览器扩展</li>
</ol>

<h2>结语</h2>
<p>隐私保护不是一次性的事情，而是一个持续的过程。养成良好的网络安全习惯，定期检查自己的数字足迹，才能在这个高度互联的世界中保护好自己的个人信息。</p>`,
    categorySlug: 'privacy-protection',
    categoryName: '隐私保护',
    author: '安全指南编辑部',
    publishedAt: '2026-07-15',
    updatedAt: '2026-07-22',
    readTime: '9 分钟',
    tags: ['隐私保护', '数据安全', '个人信息', '网络安全'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20lock%20icon%20with%20digital%20data%20streams%2C%20warm%20cream%20and%20amber%20background%2C%20soft%20diffused%20lighting%2C%20clean%20professional%20style%2C%20privacy%20protection%20concept&width=1200&height=600&seq=article-privacy-full&orientation=landscape',
  },
  {
    id: 'art-4',
    slug: 'identify-official-versions',
    title: '官方版本辨别指南：教你一眼识别真假',
    excerpt: '面对网络上众多的"91视频"版本，如何在众多选项中快速找出官方正版？本文提供一套完整的版本鉴别方法论。',
    content: `<p>在互联网上搜索特定应用时，经常会看到大量声称是"官方版本"的下载链接。这些链接中，真实可靠的寥寥无几。掌握版本辨别的方法，是安全使用任何软件的前提。</p>

<h2>官方版本的三大特征</h2>

<h3>1. 数字签名验证</h3>
<p>所有正规发布的软件安装包都带有开发者的数字签名。你可以右键点击安装文件，选择"属性"→"数字签名"来查看签名信息。合法的签名应显示为"该数字签名正常"，并可以追溯到可信的开发者。</p>
<p>如果文件没有数字签名，或者签名显示"无效"或"不受信任"，那么这个文件极有可能被篡改过。</p>

<h3>2. 文件哈希校验</h3>
<p>官方发布通常会公布安装文件的MD5、SHA1或SHA256哈希值。下载后，你可以使用哈希计算工具验证下载文件的哈希值是否与官方公布的一致。任何不一致都表明文件已被修改。</p>

<h3>3. 官方渠道确认</h3>
<p>最可靠的版本辨别方法是溯源至官方发布渠道。正规软件通常有明确的官方网站，且在首页有清晰的下载入口。通过搜索引擎搜索到的第三方下载站的链接需要格外谨慎对待。</p>

<h2>常见的虚假版本特征</h2>
<ul>
<li>安装包体积异常（过小或过大）</li>
<li>安装界面存在广告或推广其他软件</li>
<li>安装过程中要求过多的系统权限</li>
<li>应用图标模糊或与官方不一致</li>
<li>应用启动后立即要求登录（盗取账号）</li>
</ul>

<h2>推荐的安全下载流程</h2>
<ol>
<li>先确认官方网站的真实地址</li>
<li>从官方页面找到下载入口</li>
<li>下载前查看浏览器地址栏的锁形标志</li>
<li>下载后验证数字签名和文件哈希值</li>
<li>安装前使用安全软件扫描</li>
<li>安装时留意权限请求是否合理</li>
</ol>`,
    categorySlug: 'version-guide',
    categoryName: '版本辨别',
    author: '安全指南编辑部',
    publishedAt: '2026-07-12',
    updatedAt: '2026-07-21',
    readTime: '7 分钟',
    tags: ['版本辨别', '数字签名', '哈希校验', '官方渠道'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20checkmark%20verification%20concept%20on%20computer%20screen%2C%20warm%20cream%20and%20amber%20background%2C%20soft%20lighting%2C%20clean%20professional%20editorial%20style%2C%20digital%20certificate%20theme&width=1200&height=600&seq=article-version-full&orientation=landscape',
  },
  {
    id: 'art-5',
    slug: 'phishing-attack-prevention',
    title: '钓鱼攻击防范手册：别让一次点击毁了你的账户',
    excerpt: '钓鱼攻击是最常见且最有效的网络诈骗手段之一。本文详细讲解钓鱼攻击的运作方式及有效的防范策略。',
    content: `<p>钓鱼攻击（Phishing）是一种通过伪装成可信实体来诱骗用户泄露敏感信息的攻击手段。攻击者通常会发送看似来自银行、社交平台或服务提供商的邮件或消息，引导用户点击链接并输入账号密码。</p>

<h2>钓鱼攻击的常见形式</h2>

<h3>1. 邮件钓鱼</h3>
<p>攻击者发送伪装成官方通知的邮件，声称"账户异常"、"需要验证"或"有安全风险"，诱导用户点击邮件中的链接。这些链接表面上看起来与真实网址无异，实际上指向一个精心设计的假冒登录页面。</p>

<h3>2. 短信钓鱼（Smishing）</h3>
<p>通过手机短信发送虚假信息，通常以"快递送达通知"、"银行验证"或"中奖信息"为诱饵，附带一个短链接。点击后可能直接下载恶意软件或跳转到钓鱼页面。</p>

<h3>3. 社交平台钓鱼</h3>
<p>在社交媒体上，攻击者可能创建高仿官方账号，发布抽奖活动或优惠信息，引导用户访问外部钓鱼页面。或者通过私信发送文件或链接，利用用户的信任关系进行攻击。</p>

<h2>如何识别钓鱼攻击</h2>

<h3>检查发件人/发送者</h3>
<p>仔细查看发件人的完整邮箱地址，而非仅显示名称。正规机构的邮件通常来自其官方域名。任何使用免费邮箱（如@gmail.com、@qq.com）发送的"官方通知"都高度可疑。</p>

<h3>悬停查看链接目标</h3>
<p>在点击任何链接之前，先将鼠标悬停在链接上（移动端可以长按），查看浏览器底部显示的完整链接地址。如果链接地址与声称的来源不符，绝对不要点击。</p>

<h3>注意语气和紧迫感</h3>
<p>钓鱼信息通常会制造紧迫感，使用"立即"、"紧急"、"最后通知"、"您的账户将被冻结"等措辞来降低你的警惕性和判断力。正规机构一般不会使用这种高压式沟通。</p>

<h3>检查语法和格式</h3>
<p>虽然现在的钓鱼攻击越来越专业，但很多仍存在语法错误、翻译痕迹或格式不统一的问题。注意查看邮件是否使用了奇怪的表达方式或不专业的排版。</p>

<h2>防范措施总结</h2>
<ol>
<li>不要点击来历不明的链接，手动输入网址访问</li>
<li>为重要账号开启双因素认证</li>
<li>怀疑账号被钓鱼后，立即修改密码</li>
<li>向相关平台和公安机关举报钓鱼页面</li>
<li>定期进行网络安全意识培训</li>
</ol>`,
    categorySlug: 'security-news',
    categoryName: '安全资讯',
    author: '安全指南编辑部',
    publishedAt: '2026-07-10',
    updatedAt: '2026-07-20',
    readTime: '8 分钟',
    tags: ['钓鱼攻击', '网络诈骗', '信息安全', '防范策略'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20fishing%20hook%20concept%20in%20digital%20context%2C%20warm%20cream%20and%20amber%20background%2C%20soft%20lighting%2C%20clean%20professional%20style%2C%20cybersecurity%20phishing%20theme&width=1200&height=600&seq=article-phishing-full&orientation=landscape',
  },
  {
    id: 'art-6',
    slug: 'safe-browsing-habits',
    title: '养成安全上网习惯：从入门到进阶的完整指南',
    excerpt: '安全上网不是靠一款软件就能实现的，而是需要培养全面的安全意识和行为习惯。这份指南覆盖从基础到进阶的各个方面。',
    content: `<p>很多人以为安装了杀毒软件就可以高枕无忧，这其实是一个危险的误解。网络安全是一个系统工程，技术防护只是其中一环，更重要的是用户自身的安全意识和日常行为习惯。</p>

<h2>基础篇：人人必须做到的五件事</h2>

<h3>1. 使用密码管理器</h3>
<p>记住数十个不同的复杂密码对人类来说几乎是不可能的，这就是为什么很多人会重复使用简单密码。密码管理器可以帮你生成和存储高强度的唯一密码，你只需要记住一个主密码。</p>

<h3>2. 定期更新所有软件</h3>
<p>不只是操作系统，还包括浏览器、办公软件、媒体播放器等所有你日常使用的应用。许多攻击利用的是已知漏洞，而这些漏洞在最新版本中早已被修复。</p>

<h3>3. 备份重要数据</h3>
<p>遵循"3-2-1"备份原则：至少保留3份数据副本，使用2种不同的存储介质，其中1份存放在异地。这样即使遭遇勒索软件攻击，也能从容恢复数据。</p>

<h3>4. 谨慎对待免费服务</h3>
<p>如果一项在线服务是免费的，那么你很可能就是"产品"本身。免费VPN、免费文件转换、免费在线工具等，可能正在收集和出售你的数据。使用前请仔细阅读隐私政策。</p>

<h3>5. 学会说"不"</h3>
<p>对于不必要的权限请求、可疑的下载提示、来源不明的文件分享，学会坚定地说"不"。拒绝是保护自己的最好方式之一。</p>

<h2>进阶篇：提升你的安全防护等级</h2>

<h3>使用虚拟机隔离风险环境</h3>
<p>当你需要访问不明网站或测试未知软件时，在虚拟机中进行操作可以有效隔离风险。即使虚拟机被感染，宿主机仍然安全。</p>

<h3>配置网络防火墙规则</h3>
<p>了解并配置操作系统内置防火墙的出站规则，可以有效阻止恶意软件与外部控制服务器的通信。</p>

<h3>学习基础的编程和命令行操作</h3>
<p>了解计算机的基本工作原理，能够读懂简单的命令行操作，这对识别和应对安全威胁非常有帮助。</p>`,
    categorySlug: 'usage-guide',
    categoryName: '使用说明',
    author: '安全指南编辑部',
    publishedAt: '2026-07-08',
    updatedAt: '2026-07-18',
    readTime: '11 分钟',
    tags: ['安全习惯', '密码管理', '数据备份', '上网安全'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20workspace%20with%20laptop%20and%20coffee%2C%20warm%20cream%20and%20amber%20tones%2C%20soft%20natural%20lighting%2C%20professional%20editorial%20style%2C%20calm%20productive%20atmosphere&width=1200&height=600&seq=article-safe-browsing-full&orientation=landscape',
  },
];